import axios from "axios";
import {Convert} from "@/utils/convert";

export default class OrganizationService {

    getOrganizationLogo(organizationId) {
        return axios.get(`api/v4/organizations/${organizationId}/logo`, {responseType: 'arraybuffer'})
            .then((response) => {
                const base64logo = Convert.arrayBufferToBase64(response.data);
                return `data:image/png;base64,${base64logo}`;
            });
    }

    getOrganizationTree() {
        return axios.get(`/api/v4/organizations?summarized=true`);
    }

    getAssociate(organizationId, userId) {
        return axios.get(`/api/v4/organizations/${organizationId}/associates/${userId}`);
    }

    getAssociates(organizationId) {
        return axios.get(`/api/v4/organizations/${organizationId}/associates`);
    }

    associateUser(organizationId, role, email) {
        return axios.post(`/api/v4/organizations/${organizationId}/associates`, {
            email: email,
            role: role
        });
    }

    createGuest(organizationId, userDetails) {
        return axios.post(`/api/v4/organizations/${organizationId}/associates/guests`, userDetails);
    }

    disassociateUser(organizationId, userId) {
        return axios.delete(`/api/v4/organizations/${organizationId}/associates/${userId}`);
    }
}
